const firebaseConfig = {
  apiKey: "AIzaSyChDXseuHj5RRYlsI58POL6x8y_7jki30A",
  authDomain: "life-healer.firebaseapp.com",
  projectId: "life-healer",
  storageBucket: "life-healer.appspot.com",
  messagingSenderId: "100721017252",
  appId: "1:100721017252:web:f5b40fcfa14d8b14c9c131"
};
export default firebaseConfig;

